import React from 'react';
import { BankSearchResult } from '../../../../utils/types/candi_bank_types';

export interface UnverifiedDrawerProps {
  unverifiedCount: number;
  expanded: boolean;
  onToggle: () => void;
  unverifiedResults: BankSearchResult[];
  onViewProfile: (result: BankSearchResult) => void;
}

export const UnverifiedDrawer: React.FC<UnverifiedDrawerProps> = ({
  unverifiedCount,
  expanded,
  onToggle,
  unverifiedResults,
  onViewProfile
}) => {
  if (unverifiedCount <= 0) return null;

  return (
    <div className="w-full my-4">
      <div className="flex justify-center">
        <button
          onClick={onToggle}
          className="flex items-center gap-2 px-4 py-2 bg-slate-100/90 hover:bg-slate-200 text-slate-600 rounded-full text-xs font-bold transition-all border border-slate-200/60 shadow-2xs"
        >
          <span>{unverifiedCount} candidates with unparseable CV dates</span>
          <svg className={`w-3.5 h-3.5 transition-transform ${expanded ? 'rotate-180' : ''}`} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="6 9 12 15 18 9" />
          </svg>
        </button>
      </div>

      {expanded && (
        <div className="mt-3 p-4 bg-slate-50/60 border border-slate-200/80 rounded-2xl shadow-xs opacity-75">
          <div className="overflow-x-auto">
            <table className="w-full text-xs text-left text-slate-600">
              <thead className="text-[10px] text-slate-400 uppercase bg-slate-100/80 font-bold border-b border-slate-200/60">
                <tr>
                  <th className="px-4 py-2.5">Name</th>
                  <th className="px-4 py-2.5">Email</th>
                  <th className="px-4 py-2.5">Skills</th>
                  <th className="px-4 py-2.5">Years</th>
                  <th className="px-4 py-2.5 text-right">Action</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100">
                {unverifiedResults.length === 0 ? (
                  <tr>
                    <td colSpan={5} className="px-4 py-4 text-center text-slate-400">
                      Loading unverified candidates...
                    </td>
                  </tr>
                ) : (
                  unverifiedResults.map((result, idx) => {
                    const skills = result.skills ? result.skills.slice(0, 5).join(', ') : 'N/A';
                    const name = [result.firstName, result.lastName].filter(Boolean).join(' ') || 'Unknown';
                    
                    return (
                      <tr key={result.id || idx} className="hover:bg-slate-100/50 transition-colors">
                        <td className="px-4 py-2.5 font-bold text-slate-800">{name}</td>
                        <td className="px-4 py-2.5 font-mono text-[11px] text-slate-500">{result.email || '—'}</td>
                        <td className="px-4 py-2.5">{skills}</td>
                        <td className="px-4 py-2.5">{result.years !== undefined ? `${result.years}y` : '—'}</td>
                        <td className="px-4 py-2.5 text-right">
                          <button
                            onClick={() => onViewProfile(result)}
                            className="text-indigo-600 hover:text-indigo-800 font-bold inline-flex items-center gap-1 text-[11px]"
                          >
                            <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                              <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                              <circle cx="12" cy="12" r="3" />
                            </svg>
                            View
                          </button>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};
